import React, {useEffect, useState} from "react";
import {useStateContext} from "../../helpers/state-context/use_state_context.js";
import {Info} from "./info.js";
import {Share} from "./share.js";
import InfoIcon from '../../assets/Info.svg'
import CloseIcon from '../../assets/close_S_white.svg'
import ShareIcon from '../../assets/Share.svg';
import BellIcon from '../../assets/bell.svg';
import {ReactComponent as FeedbackIcon} from '../../assets/feedback.svg';
import {CircleIcon} from "../ui/circle-icon.js";
import {CountryList} from '../country-list.js';
import {Survey} from '../survey.js';
import {ModelConsumer} from '../../helpers/model/model-consumer.js';
import {ModelCountriesMain} from '../../models/country.js';
import {Analytics} from '../../helpers/analytics';

const buttonContainer = {
    position: 'fixed',
    left: '1%',
    bottom: '1%',
    color: 'rgb(29, 43, 125)',
    display: 'flex',
    alignItems: 'center',
    zIndex: 15,
}

function InfoShareButtons(){
    const [showShare, setShare] = useState(false);
    const [showActiveCountries, setActiveCountries] = useState(false);
    const [surveyIsOpen, setSurveyIsOpen] = useState(false);
    const [state, dispatch] = useStateContext(['renderSize', 'page', 'selectedCategory', 'country', 'categories']);
    const viewSize = ['xs', 'sm'].includes(state.renderSize) ? 'small' : 'full';

    const toggleItem = (item) =>{
        if(item === null &&  state.selectedCategory){
            dispatch({type: 'selectedCategory', value: null});
            dispatch({type: 'setDefaultCategories'});
        }
        dispatch({type: 'country', value: null});
        dispatch({type: 'setDefaultCategories'});
        dispatch({type: 'page', value: state.page === item ? null : item});
    };

    useEffect(()=>{
        if(state.page === 'more-info'){
            window.scrollBy({top: 100, left: 0,behavior: 'smooth'})
        }else{
            window.scrollTo({top: 0, left: 0,behavior: 'smooth'})
        }
    }, [state.page]);

    useEffect(() => {
        let timerId = null;
        if(! localStorage.getItem('permits-survey-done')){
            timerId = setTimeout(() => {
                setSurveyIsOpen(true);
            }, 20 * 1000);
        }
        return () => {
            clearTimeout(timerId);
        }
    }, []);


    return  <div id={'more-buttons'}>
        {(state.page === 'more-info') ?
                <Info/> :
                null
        }
        {(showShare) ?
                <Share onClose={()=>setShare(false)}/> :
                null
        }
        {(showActiveCountries) ?
            <ModelConsumer model={ModelCountriesMain}>
                {(resultSet)=>{
                    const countries = resultSet.data.values.filter((c)=>c.is_active);
                    return <CountryList title={'Where we are engaging right now'}
                                        bell={true}
                                        onCountrySelect={(country)=>{
                                            setActiveCountries(false);
                                            Analytics.trackEvent({
                                                action: 'select country',
                                                category: 'country list',
                                                label: country.country_name
                                            });
                                            dispatch({type: 'page', value: 'country'});
                                            dispatch({type: 'country', value: country.country_code});
                                        }}
                                        showCountryLink={true}
                                        countries={countries}
                                        description={'In the following countries, Permits Foundation is currently ' +
                                        'gathering feedback from our local network and/or making contact with policy' +
                                        ' makers with a view to improving work access for dependants of highly-skilled mobile employees.' +
                                        ' Check the individual country pages to find out more about Permits Foundation’s ' +
                                        'current activity in these countries.'}
                                        onClose={()=>setActiveCountries(false)}/>
                }}
            </ModelConsumer> :
                null
        }
        {surveyIsOpen ? <Survey onClose={() => {setSurveyIsOpen(false);}}/> : null}

        <div style={{...buttonContainer, flexDirection: (viewSize === 'small') ? 'column' : 'row'}}>
            {(['more-info'].includes(state.page)) ?
                    <CircleIcon id={'close-button'}
                            onClick={()=> toggleItem(null)}
                            src={CloseIcon} style={{backgroundColor: "#1D2B7D"}}
                            alt={'close_icon'}/> :
                    <CircleIcon id={'info-button'}
                            onClick={()=> {
                                Analytics.trackEvent({
                                    action: 'select',
                                    category: 'bottomleft icons',
                                    label: 'info button'
                                });
                                toggleItem('more-info');
                            }}
                            src={InfoIcon} style={{backgroundColor: "#1D2B7D"}}
                            alt={'info_icon'}/>
            }
            <CircleIcon id={'share-button'}
                    onClick={()=> {
                        Analytics.trackEvent({
                            action: 'select',
                            category: 'bottomleft icons',
                            label: 'share button'
                        });
                        setShare((prevState)=>!prevState)
                    }}
                    src={ShareIcon}  style={{backgroundColor: "#fff"}}
                    alt={'share_icon'}/>
            <CircleIcon id={'share-button'}
                        onMouseEnter={(country)=>{
                            dispatch({type: 'countryHover', value: 'active_countries'})
                        }}
                        onMouseLeave={()=>{
                            dispatch({type: 'countryHover', value: null});
                        }}
                    onClick={()=> {
                        if(state.country){
                            dispatch({type: 'country', value: null})
                        }
                        Analytics.trackEvent({
                            action: 'select',
                            category: 'bottomleft icons',
                            label: 'engaging countries button'
                        });
                        setActiveCountries((prevState)=>!prevState)
                    }}
                    src={BellIcon}  style={{backgroundColor: "#fff", fontSize: 20}}
                    alt={'bell_icon'}/>
            <span className="btn-feedback"
                    onClick={()=> {
                        if(state.country){
                            dispatch({type: 'country', value: null})
                        }
                        Analytics.trackEvent({
                            action: 'select',
                            category: 'bottomleft icons',
                            label: 'survey'
                        });
                        setSurveyIsOpen((prevState)=>(!prevState))
                    }}>
                <FeedbackIcon/> Feedback
            </span>
        </div>
    </div>
}

export {InfoShareButtons}